export enum StatusCondition {
  USED = 0,
  NEW_SEALED = 1,
  PRE_LABELLED = 2,
}

export const StatusConditionLabels: Record<StatusCondition, string> = {
  [StatusCondition.USED]: "Used",
  [StatusCondition.NEW_SEALED]: "New Sealed",
  [StatusCondition.PRE_LABELLED]: "Pre-labelled",
};
